import { retry } from 'rxjs';

import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Renderer2,
  ViewChild,
  ViewContainerRef,
  AfterViewInit,
  QueryList,
  DOCUMENT
} from '@angular/core';
import {
  FormGroup,
  Validators,
  FormBuilder,
  AbstractControl,
  ValidatorFn,
  FormControl,
} from '@angular/forms';
import { Router } from '@angular/router';
import { PaymentService } from '@core/payments/services/payment.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LoaderService } from '@shared/services/loader.service';
import { TransactionService } from '@shared/services/transaction.service';
import { getValidationConfigFromCardNo } from 'src/app/helpers/card.helper';
import { luhnValidator } from 'src/app/validators/luhnValidator';
import { environment } from 'src/environments/environment';
import { jwtDecode } from 'jwt-decode';
import { EnableModulesService } from '@shared/services/enable-modules.service';
import { Subscription } from 'rxjs';
declare var $: any;
declare var Flex: any;

@Component({
    selector: 'app-updatecardpage',
    templateUrl: './updatecardpage.component.html',
    styleUrls: ['./updatecardpage.component.css'],
    standalone: false
})
export class UpdatecardpageComponent {
  private microform: any;

  public uploadcard: boolean = false;
  formPayment!: FormGroup;
  buttonClass = '';
  formValid = false;
  saveCard: boolean = false;
  isButtonEnabled = false;
  idSessionToken: string = '';
  flexSrc = environment.microform_src;
  emailForDom: string = '';
  cardType: any = '';
  private transientToken: string = '';
  private cardBin: string = '';
  private expirationDate: string = '';
  formattedMaskedValue: string = '';
  public numbermodule: number = 0;

  constructor(
    public _paymentService: PaymentService,
    private el: ElementRef,
    private fb: FormBuilder,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private _loaderService: LoaderService
  ) {
    // console.clear();
    //Si viene el parametro rfc en la url, quiere decir que vamos a actualizar
    // if (this._paymentService.uploadcard) {
    //   this._paymentService.generateToken('user123').subscribe((res) => {
    //     this._paymentService
    //       .getTokenizacion(this._paymentService.numberphone, res)
    //       .subscribe(
    //         (response) => {
    //           console.log(response);
    //           this.uploadcard = true;
    //           this.formPayment.get('emailAddress')!.setValue(response.email);
    //         },
    //         (error) => {
    //           console.error('Error:', error);
    //         }
    //       );
    //   });
    // }
    // if (this._paymentService.uploadcard) {
    //   this._paymentService.generateToken('user123')
    //     .pipe(retry(2)) // Reintenta ejecutar la lógica 2 veces si ocurre un error
    //     .subscribe((res) => {
    //       this._paymentService
    //         .getTokenizacion(this._paymentService.numberphone, res)
    //         .pipe(retry(2)) // Reintenta también esta solicitud 2 veces en caso de error
    //         .subscribe(
    //           (response) => {
    //             console.log(response);
    //             this.uploadcard = true;
    //             this.formPayment.get('emailAddress')!.setValue(response.email);
    //           },
    //           (error) => {
    //             console.error('Error después de 2 reintentos:', error);
    //           }
    //         );
    //     });
    // }
    this.emailForDom = this._paymentService.emailFromDom;
    this.formPayment = this.fb.group({
      expirationDate: [
        '',
        [Validators.required, Validators.minLength(5), this.DateValidator()],
      ],
      emailAddress: [
        { value: this.emailForDom, disabled: true },
        [
          Validators.required,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ],
      ],
      isLinked: [this.saveCard],
      aceptarterminos: ['', Validators.required],
      afiliartarjeta: [null],
    });
  }

  ngAfterViewInit(): void {
    // Inicializa todos los tooltips que tengan el atributo data-toggle="tooltip"
    $('[data-toggle="tooltip"]').tooltip();
  }

  ngOnInit(): void {
    this._paymentService.email = this.emailForDom;
    this._paymentService.afilcard = true;
    this.addFingerPrintScript();
    this.initMicroform();
    this.formPayment.valueChanges.subscribe(() => {
      this.formValid = false;
      this.isButtonEnabled = false;
      if (this.formPayment.valid && this.formPayment.value.aceptarterminos) {
        this.formValid = true;
        this.isButtonEnabled = true;
      }
      this.buttonClass = this.isButtonEnabled
        ? 'btnPrimary'
        : 'btnPrimaryDisabled';
    });
  }

  public DateValidator(): ValidatorFn {
    return () => {
      const expirationDateVar = this.formPayment?.get('expirationDate')?.value;
      if (!expirationDateVar) {
        // expirationDateVar es indefinida o nula
        return null; // O devuelve un error personalizado si es necesario
      }
      const arrayDate = expirationDateVar.split('/');
      const currentYear: any = new Date().getFullYear();
      const currentMonth = new Date().getMonth() + 1;
      const month = arrayDate[0];
      const year = arrayDate[1];
      if (isNaN(month) || isNaN(year)) {
        return { isValid: true };
      }
      if (parseInt(month) > 12) {
        return { isValid: true };
      }
      if (parseInt(year) < currentYear.toString().substr(2, 4)) {
        return { isValid: true };
      }
      if (parseInt(year) == currentYear.toString().substr(2, 4)) {
        if (parseInt(month) < currentMonth) {
          return { isValid: true };
        }
      }
      return null;
    };
  }

  dateFormat(value: any) {
    if (!isNaN(value.value) && value.value !== null) {
      const formattedDate = value.value.replace(/\D/g, '');
      if (formattedDate.length > 2) {
        const month = formattedDate.substring(0, 2);
        const year = formattedDate.substring(2);
        this.formPayment.controls['expirationDate'].setValue(
          `${month}/${year}`
        );
      }
    }
  }

  justNumbersDate(event: any) {
    // Eliminar todos los caracteres que no sean números ni "/"
    const inputValue = event.target.value;
    const numbersAndSlashOnly = inputValue.replace(/[^0-9/]/g, '');
    event.target.value = numbersAndSlashOnly;
  }

  private bytesToHex(bytes: Uint8Array): string {
    return Array.from(bytes)
      .map((byte) => byte.toString(16).padStart(2, '0'))
      .join('');
  }

  addFingerPrintScript() {
    // SCRIPT FINGERPRINT
    const randomBytes = new Uint8Array(15);
    const rerollBytes = crypto.getRandomValues(randomBytes);
    this.idSessionToken = this.bytesToHex(rerollBytes);
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src =
      environment.t1_fingerscript_src +
      '?org_id=' +
      environment.t1_orgid_dfp +
      '&session_id=' +
      localStorage.getItem('t1_merchant_id') +
      this.idSessionToken;

    this._renderer2.appendChild(this._document.head, script);

    //IFRAME FINGERPRINT
    let noscript = this._renderer2.createElement('noscript');
    let iframeT1 = this._renderer2.createElement('iframe');
    iframeT1.src =
      environment.t1_fingerscript_src +
      '?org_id=' +
      environment.t1_orgid_dfp +
      '&session_id=' +
      localStorage.getItem('t1_merchant_id') +
      this.idSessionToken;
    iframeT1.style =
      'width: 100px; height: 100px; border: 0; position:absolute; top: -5000px;';
    this._renderer2.appendChild(noscript, iframeT1);
    this._renderer2.appendChild(this._document.body, noscript);
  }

  initMicroform() {
    const script = this._renderer2.createElement('script');
    script.type = 'text/javascript';
    script.src = this.flexSrc;
    script.onload = () => {
      var customStyles = {
        input: {
          'font-size': '16px',
        },
        ':hover': {
          'font-style': 'italic',
        },
        ':disabled': {
          cursor: 'not-allowed',
        },
        valid: {
          color: 'green',
        },
        invalid: {
          color: 'red',
        },
      };
      const flex = new Flex(localStorage.getItem('captureContext'));
      this.microform = flex.microform({ styles: customStyles });
      const number = this.microform.createField('number', {
        placeholder: 'Número de tarjeta',
      });
      const securityCode = this.microform.createField('securityCode', {
        placeholder: '***',
      });
      number.load('#cardNumber');
      securityCode.load('#cardSC');
    };
    this._renderer2.appendChild(document.body, script);
  }

  getCardNumberControl(): AbstractControl | null {
    return this.formPayment.get('cardNumber');
  }

  sendUpdateCardForm(): void {
    this.formPayment.controls['isLinked'].setValue(this.saveCard);
    const bodyRequest = this.formPayment.value;
    bodyRequest.idSession = this.idSessionToken;
    bodyRequest.franchise = this.cardType;
    this._loaderService.blockLoading();
    const expirationDate = bodyRequest.expirationDate.split('/');

    const options = {
      expirationMonth: expirationDate[0],
      expirationYear: '20' + expirationDate[1],
    };

    this.microform.createToken(options, (err: any, token: string) => {
      if (err) {
      } else {
        this.transientToken = token;
        console.log(this.transientToken);

        this._paymentService.tokencard = token;
        const decodedPayload = this.decodeToken(token);
        this.cardBin =
          decodedPayload.content.paymentInformation.card.number.bin;

        this.expirationDate =
          decodedPayload.content.paymentInformation.card.expirationMonth.value +
          '/' +
          decodedPayload.content.paymentInformation.card.expirationYear.value;

        this.formattedMaskedValue = this.formatMaskedValue(
          decodedPayload.content.paymentInformation.card.number.maskedValue,
          this.cardBin
        );

        this._paymentService.bindcardgen = this.formattedMaskedValue;
        this._paymentService.expiratesdatecard = this.expirationDate;
        // this._paymentService.email = bodyRequest.emailAddress;
        bodyRequest.transientToken = token;
        bodyRequest.captureContext = localStorage.getItem('captureContext');
        this._paymentService.bodyrequestcard = bodyRequest;
        this._paymentService.numbermodule = 1;
      }
    });
  }

  decodeToken(token: string): any {
    try {
      const decodedToken = jwtDecode(token);
      return decodedToken;
    } catch (error) {
      console.error('Error decoding token:', error);
      return null;
    }
  }

  formatMaskedValue(maskedValue: string, bin: string): string {
    const firstFourBin = bin.slice(0, 4); // Obtener los primeros 4 dígitos del bin
    const lastDigits = maskedValue.slice(-4); // Obtener los últimos 4 dígitos del maskedValue
    const maskedSection = '*'.repeat(maskedValue.length - 8); // Crear los asteriscos para la sección enmascarada

    return `${firstFourBin}${maskedSection}${lastDigits}`;
  }
}
